module.exports = __webpack_public_path__ + "img/download.fc05f91d.png";